function tooltip (btn, tool) {
    var btn = document.getElementById(btn);
    var tool = document.getElementById(tool);  
    var open = false;
 
     tool.addEventListener('click', function(event){
          event.stopPropagation();
     });
 
    btn.addEventListener('click', function(event){
       event.stopPropagation();
       if(!open){
          tool.classList.add('pop');
          open = true;
  
       }else{
          tool.classList.remove('pop');
          open = false;
       }
       console.log('clicked');
    });
 
 }
 
 tooltip('boton', 'tooltip');